import React from 'react';
import PropTypes from 'prop-types';
import Radio from 'arts/components/Radio';
import * as Classes from './styles.module.scss';

const Mount = ({
  isSelected, kind, name, description, onSelect, paperId, postFix, children, wallBuilderMode
}) => {
  const radioId = `MountRadioControl-${ paperId }-${ kind }`;
  const radioName = `MountRadioControl-${ paperId }-${ postFix }`;

  return (
    <div key={ kind }>
      <label
        htmlFor={ radioId }
        key={ kind }
      >
        <div className={ Classes.mountOption }>
          <Radio
            type="radio"
            value={ kind }
            checked={ isSelected }
            onChange={ onSelect }
            id={ radioId }
            name={ radioName }
          />

          <div className={ Classes.mount }>
            { name }
            <span className={ wallBuilderMode ? Classes.wallBuilderDescription : '' }>
              { description }
            </span>
          </div>
        </div>
      </label>
      { children }
    </div>
  );
};

Mount.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  kind: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  paperId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  postFix: PropTypes.string,
  children: PropTypes.node,
  wallBuilderMode: PropTypes.bool
};

export default Mount;
